import { navigationManager } from '@modules/navigation/NavigationManager.js';

class KeyboardNavigation {
  constructor() {
    this._keyDownHandler = this._handleKeyDown.bind(this);
    this._setupEventListeners();
  }

  _setupEventListeners() {
    document.addEventListener('keydown', this._keyDownHandler);
  }

  _handleKeyDown(event) {
    switch (event.key) {
      case 'm':
      case 'M':
        navigationManager.handleNavigationAction('focus-moon');
        break;
      case 'i':
      case 'I':
        navigationManager.handleNavigationAction('focus-iss');
        break;
      case 'r':
      case 'R':
        navigationManager.handleNavigationAction('reset-camera');
        break;
      case 'ArrowLeft':
        this._navigateToPreviousPlanet();
        break;
      case 'ArrowRight':
        this._navigateToNextPlanet();
        break;
      default:
        break;
    }
  }

  _navigateToPreviousPlanet() {
    const planets = navigationManager.sceneObjects.planets;
    if (planets && planets.length > 0) {
      let newIndex = navigationManager.currentPlanetIndex - 1;
      if (newIndex < 0) newIndex = planets.length - 1;
      navigationManager.focusOnObject(planets[newIndex].group);
    }
  }

  _navigateToNextPlanet() {
    const planets = navigationManager.sceneObjects.planets;
    if (planets && planets.length > 0) {
      let newIndex = navigationManager.currentPlanetIndex + 1;
      if (newIndex >= planets.length) newIndex = 0;
      navigationManager.focusOnObject(planets[newIndex].group);
    }
  }

  cleanup() {
    document.removeEventListener('keydown', this._keyDownHandler);
  }
}

export default KeyboardNavigation;